import React, { useState, useEffect  } from "react";
import ProfilePicture from "./ProfilePicture";
import ProfileUploadedPictures from "./ProfileUploadedPictures";
import ProfileWardrobe from "./ProfileWardrobe";
import { useSelector } from "react-redux";
const Profile = () => {
  // const ProfileWardrobe = lazy(() => import ('./ProfileWardrobe'))
  const user = useSelector((state) => state.userSelectReducer.user);
  let data = JSON.parse(sessionStorage.getItem("user"));
  console.log("The user of the data for profile", data);
  const [isUserImagesSelected, setisUserImagesSelected] = useState(false);
  const [isUserWardrobeSelected, setisUserWardrobeSelected] = useState(true);
  const openUserImagesComponent = () => {
    setisUserImagesSelected(!isUserImagesSelected);
    setisUserWardrobeSelected(!isUserWardrobeSelected);
  };

  useEffect(() => {   
    console.log("LOADING PROFILE")
   }, []);
  const openUserWardrobeComponent = () => {
    setisUserImagesSelected(!isUserImagesSelected);
    setisUserWardrobeSelected(!isUserWardrobeSelected);
  };

  return (
    <>
      <div className="flex flex-col justify-center items-center space-y-3 p-16">
        <ProfilePicture user={data} />
        <h1 className="text-white font-bold">{data.username}</h1>
        <div className="flex flex-row items-center justify-center space-x-12">
          <div
            className={`border-white hover:bg-opacity-95 cursor-pointer ${
              isUserWardrobeSelected ? "border-4" : "border-0"
            }`}
            onClick={openUserWardrobeComponent}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-10"
              fill="#FFFFFF"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M5 8h14M5 8a2 2 0 110-4h14a2 2 0 110 4M5 8v10a2 2 0 002 2h10a2 2 0 002-2V8m-9 4h4"
              />
            </svg>
          </div>
          <div
            className={`border-white hover:bg-opacity-95 cursor-pointer ${
              isUserImagesSelected ? "border-4" : "border-0"
            }`}
            onClick={openUserImagesComponent}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              class="h-10"
              fill="#FFFFFF"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
              />
            </svg>
          </div>
        </div>
      </div>
      <ProfileUploadedPictures
        isHidden={isUserImagesSelected}
        userId={data.id}
      />
      <ProfileWardrobe isHidden={isUserWardrobeSelected} userId={data.id} />
    </>
  );
};

export default Profile;
